import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast, SuccessToast } from 'components/Toast';
import { STRINGS } from 'config';
import React from 'react';

const {
  SUMMARISER: { HOST },
} = STRINGS;

export async function sendFeedback(comment: string, details: object): Promise<void> {
  try {
    const response = await fetch(`${HOST}/feedback`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ comment, details }),
    });
    const result = response;
    if (result.status !== 201) {
      toast.error(
        React.createElement(ErrorToast, {
          message: 'Sorry, we could not process your feedback submission. Please try again.',
        }),
        {
          autoClose: 12000,
          pauseOnHover: true,
          hideProgressBar: false,
          closeOnClick: true,
          icon: false,
        },
      );
      throw new Error('Feedback submission failed.');
    }
    toast.success(
      React.createElement(SuccessToast, {
        message: 'Thank you for your feedback!',
      }),
      { icon: false },
    );
  } catch (error) {
    console.error('Error sending feedback:', error);
  }
}
